import { Component, OnInit } from '@angular/core';
import { LibraryService, Dropobj } from '../../services/library.service';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-opac',
  templateUrl: './opac.component.html',
  styleUrls: ['./opac.component.scss'],
  providers:[LibraryService]
})
export class OpacComponent implements OnInit {
  arrbooks:any=[];
  dashcount:any={};
  pdfSrc="";
  servalue='L';
  sertxt="";
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal) {  }

  ngOnInit(): void {
    this.getopacbookdash();
    this.getopacbooks('seltop','');
  }

  applybooksFilter(filterValue: string) {
    debugger
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    if(filterValue.length>=3)
    {
      if (this.servalue=="L")
      {
      this.getopacbooks('serchbook',filterValue);
      }
      else{
        this.getopacglobbooks(filterValue);
      }
      
    
  }
  else 
  {
    this.getopacbooks('seltop','');
  }
  
  }
  getopacbooks(oprtype,sertxt) {
    this.liservice.getopacbooks(sertxt,oprtype)
        .subscribe(
        resultArray => {
            console.log('opacbks', resultArray);
            this.arrbooks = resultArray;
            
            
        },
        error => console.log("Error :: " + error)
        )
  }

  viewpdf(content,bkid)
{

  this.pdfSrc=this.liservice.pdfurl+bkid;
  this.modalOptions={size:'lg'};
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}


  getopacglobbooks(sertxt) {
    debugger
    this.liservice.getopacglobbooks(sertxt)
        .subscribe(
        resultArray => {
            console.log('opacbks', resultArray);
            this.arrbooks = resultArray;
            
            
        },
        error => console.log("Error :: " + error)
        )
  }

  onchangeradio(ent)
  {
    if(ent.target.value=="L")
    {
      this.servalue="L";
    }
    else{

      this.servalue="G";
    }
    this.applybooksFilter(this.sertxt);
    console.log('ser',this.servalue);
    
  }

   test(inp) {

    alert(inp);
    
  }

  getopacbookdash() {
    this.liservice.getopacbookdash()
        .subscribe(
        resultArray => {
            console.log('dashcount', resultArray);
            this.dashcount = resultArray;
            
            
        },
        error => console.log("Error :: " + error)
        )
  }
}
